var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"component_link"},[_c('v-tooltip',{attrs:{"left":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-icon',_vm._g(_vm._b({},'v-icon',attrs,false),on),[_vm._v(_vm._s(_vm.menuLink.icon))])]}}])},[_c('span',[_vm._v(_vm._s(_vm.menuLink.title))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }